import type { Distance, Pixel } from "@pdfking/math"
import type { PlottingContext } from "../types/options/PlottingContext"
import { HorizontalAlign } from "../types/align/HorizontalAlign"
import { VerticalAlign } from "../types/align/VerticalAlign"

export const CreateContext = <T>(
  context: Partial<PlottingContext<T>>
): PlottingContext<T> => ({
  color_map: {},
  file_map: {},
  font_family: "Helvetica",
  font_size: 12 as Pixel,
  horizontal_align: HorizontalAlign.CENTER,
  image_dpi: 300 as Pixel,
  page_bleed: 0 as Distance,
  stroke_width: 1 as Distance,
  unit_to_px: 1,
  vertical_align: VerticalAlign.CENTER,
  ...context,
})
